// src/components/learning/placement/BanniereTestPlacement.js
// Bannière optionnelle sur le dashboard élève
// Disparaît après le test ou après 3 refus

import React, { useState, useEffect } from 'react';
import axios from 'axios';
import TestPlacement from './TestPlacement';

const API = process.env.REACT_APP_API_URL;

export default function BanniereTestPlacement({ token }) {
  const [show, setShow] = useState(false);
  const [showTest, setShowTest] = useState(false);
  const [testFait, setTestFait] = useState(false);

  useEffect(() => {
    if (!token) return;

    // Vérifier si le test a déjà été fait
    axios.get(`${API}/progression/test-placement/status`, {
      headers: { Authorization: `Bearer ${token}` }
    }).then(res => {
      if (!res.data.test_fait) {
        // Vérifier le nombre de refus
        const refus = parseInt(localStorage.getItem('test_placement_refus') || '0');
        if (refus < 3) setShow(true);
      }
    }).catch(() => {
      // Si erreur, afficher quand même la bannière
      const refus = parseInt(localStorage.getItem('test_placement_refus') || '0');
      if (refus < 3) setShow(true);
    });
  }, [token]);

  const handlePlusTard = () => {
    const refus = parseInt(localStorage.getItem('test_placement_refus') || '0');
    localStorage.setItem('test_placement_refus', String(refus + 1));
    setShow(false);
  };

  const handleCompleted = (resultat) => {
    setTestFait(true);
    setShowTest(false);
    setShow(false);
    localStorage.removeItem('test_placement_refus');
  };

  if (!show || testFait) return null;

  return (
    <>
      <div style={{
        background: 'linear-gradient(135deg, #065f46, #047857)',
        borderRadius: 14, padding: '16px 20px',
        marginBottom: 20,
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        gap: 16, flexWrap: 'wrap',
        boxShadow: '0 4px 16px rgba(6,95,70,0.2)',
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <div style={{ fontSize: 32 }}>🎯</div>
          <div>
            <div style={{ fontSize: 14, fontWeight: 700, color: '#fff', marginBottom: 2 }}>
              Évalue ton niveau en 5 minutes
            </div>
            <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.75)' }}>
              15 questions · Aide ton prof à préparer tes cours
            </div>
          </div>
        </div>
        <div style={{ display: 'flex', gap: 8 }}>
          <button onClick={handlePlusTard} style={{
            padding: '8px 14px', borderRadius: 8,
            border: '1px solid rgba(255,255,255,0.3)',
            background: 'transparent', color: 'rgba(255,255,255,0.8)',
            fontSize: 12, fontWeight: 600, cursor: 'pointer',
          }}>
            Plus tard
          </button>
          <button onClick={() => setShowTest(true)} style={{
            padding: '8px 16px', borderRadius: 8, border: 'none',
            background: '#fff', color: '#065f46',
            fontSize: 12, fontWeight: 700, cursor: 'pointer',
          }}>
            Faire le test →
          </button>
        </div>
      </div>

      {showTest && (
        <TestPlacement
          token={token}
          niveau="Abjad"
          onClose={() => setShowTest(false)}
          onCompleted={handleCompleted}
        />
      )}
    </>
  );
}
